var _linearGradient, _path, _radialGradient, _circle, _circle2, _radialGradient2, _circle3, _circle4, _radialGradient3, _circle5, _circle6, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubtsupport9271F8Ad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "cL8JCd2buqBvasaPgkSU5a",
    x1: 12.686,
    x2: 35.58,
    y1: 4.592,
    y2: 41.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33bef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a85d9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cL8JCd2buqBvasaPgkSU5a)",
    d: "M42,8H6c-1.105,0-2,0.895-2,2v26c0,1.105,0.895,2,2,2h8v7.998 c0,0.891,1.077,1.337,1.707,0.707L24.412,38H42c1.105,0,2-0.895,2-2V10C44,8.895,43.105,8,42,8z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "cL8JCd2buqBvasaPgkSU5b",
    cx: 14,
    cy: 17,
    r: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 2.5,
    fill: "url(#cL8JCd2buqBvasaPgkSU5b)",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17,
    r: 1.5,
    fill: "#fff"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "cL8JCd2buqBvasaPgkSU5c",
    cx: 14,
    cy: 23,
    r: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 23,
    r: 2.5,
    fill: "url(#cL8JCd2buqBvasaPgkSU5c)",
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 23,
    r: 1.5,
    fill: "#fff"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "cL8JCd2buqBvasaPgkSU5d",
    cx: 14,
    cy: 29,
    r: 2.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 29,
    r: 2.5,
    fill: "url(#cL8JCd2buqBvasaPgkSU5d)",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 29,
    r: 1.5,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,16v2c0,0.552,0.448,1,1,1h17c0.552,0,1-0.448,1-1v-2c0-0.552-0.448-1-1-1H19 C18.448,15,18,15.448,18,16z",
    opacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.909,18.5H19.091c-0.326,0-0.591-0.265-0.591-0.591v-1.818c0-0.326,0.265-0.591,0.591-0.591 h16.818c0.326,0,0.591,0.265,0.591,0.591v1.818C36.5,18.235,36.235,18.5,35.909,18.5z",
    opacity: 0.07
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 19,
    y: 16,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18,22v2c0,0.552,0.448,1,1,1h17c0.552,0,1-0.448,1-1v-2c0-0.552-0.448-1-1-1H19 C18.448,21,18,21.448,18,22z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.909,24.5H19.091c-0.326,0-0.591-0.265-0.591-0.591v-1.818c0-0.326,0.265-0.591,0.591-0.591 h16.818c0.326,0,0.591,0.265,0.591,0.591v1.818C36.5,24.235,36.235,24.5,35.909,24.5z",
    opacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 19,
    y: 22,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28v2c0,0.552,0.448,1,1,1h17c0.552,0,1-0.448,1-1v-2c0-0.552-0.448-1-1-1H19 C18.448,27,18,27.448,18,28z",
    opacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.909,30.5H19.091c-0.326,0-0.591-0.265-0.591-0.591v-1.818c0-0.326,0.265-0.591,0.591-0.591 h16.818c0.326,0,0.591,0.265,0.591,0.591v1.818C36.5,30.235,36.235,30.5,35.909,30.5z",
    opacity: 0.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 2,
    x: 19,
    y: 28,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubtsupport9271F8Ad);
export default __webpack_public_path__ + "static/media/doubt support.9271f8ad.b1377ca26fce26cb9f0e1b1d4eb8a2cd.svg";
export { ForwardRef as ReactComponent };